import { z } from 'zod';
import { botSettingsSchema } from './bot-settings.ts';

export const createBotSchema = z.object({
  name: z.string().min(1).max(80),
});

/** `GET /api/bots?health=1` — presence of the flag widens the response to `BotListItemDto[]`. */
export const listBotsQuerySchema = z.object({
  health: z.literal('1').optional(),
});

export const updateBotSchema = z.object({
  name: z.string().min(1).max(80).optional(),
  // Replace-per-top-level-key semantics, NOT a deep merge: the route handler
  // (apps/api/src/routes/bots.ts PATCH) spreads whatever top-level keys are present here
  // (`appearance`, `leadCapture`, `allowedDomains`) over the bot's existing settings, so each
  // present key wholly replaces the same key on the stored object rather than merging inside
  // it. `.partial()` only makes the top-level keys optional — a present `appearance` object
  // still validates (and gets defaulted) against the FULL `appearanceSettingsSchema`, so
  // `{ appearance: { color: '#000000' } }` is valid and yields botName/welcome/etc. reset to
  // their schema defaults, not the previous stored values for those sub-fields.
  settings: botSettingsSchema.partial().optional(),
  // Prechat-persona spec §2 — trimmed, capped at 500 chars. `''` (after trim) is a valid
  // value and clears the note; `undefined` (key omitted) leaves the stored value untouched,
  // same "presence, not value" semantics `bots.ts`'s PATCH handler already uses for `settings`.
  personaNote: z.string().trim().max(500, 'personaNote must be 500 characters or fewer').optional(),
});
